import React, { useCallback } from "react";
import { InputNumberPadrao } from "../../components/Base";

//function TabelaGerarPedido({ dados, setDados, ...props }) {
function TabelaGerarPedido({ dados, setDados, ...props }) {

  const onValueChange = useCallback((v, inx) => {
    setDados(dados => dados.map((x, i) => i === inx ? { ...x, qtdPedido: v } : x));
  }, [setDados]);

  return (
    <table {...props} className="tabela-padrao">
      <thead>
        <th>FAB</th>
        <th>EAN</th>
        <th>REF</th>
        <th style={{ textAlign: "left" }}>PRODUTO</th>
        <th>ESTOQUE</th>
        <th>UN</th>
        <th>EMBALAGEM</th>
        <th>SUGESTÃO</th>
        <th>PEDIDO</th>
      </thead>
      <tbody>
        {(dados || []).map((x, inx) => (
          <RowProd key={inx} x={x} inx={inx} onValueChange={onValueChange} />
        ))}
      </tbody>
    </table>
  );
}

const RowProd = React.memo(({ x, inx, onValueChange }) => {
  return (<tr>
    <td>{x.fabricante}</td>
    <td>{x.ean}</td>
    <td>{x.codigo}</td>
    <td style={{ textAlign: "left" }}>{x.nome}</td>
    <td>{x.estoque}</td>
    <td>{x.un}</td>
    <td>{x.embalagem}</td>
    <td>{x.sugestao}</td>
    <td>
      <InputNumberPadrao
        min={0}
        value={x.qtdPedido}
        onChange={v => onValueChange(v, inx)}
      // onChange={v => {
      //   const aux = [...dados];
      //   aux[aux.findIndex(s => s.codigo === x.codigo)].qtdPedido = v;
      //   setDados(aux);
      // }}
      />
    </td>
  </tr>)
})

export default TabelaGerarPedido;
